/* eslint-disable react/jsx-props-no-spreading */
import PropTypes from 'prop-types'
import { useEffect, useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Route as OriginalRoute, Redirect } from 'react-router-dom'

import generalActions from 'models/General/actions'
import authSelectors from 'models/Authentication/selectors'

import { APP_URLS } from 'resources/urls'

const Route = ({ component: RouteComponent, isAuthenticatedRoute = false, ...rest }) => {
  const dispatch = useDispatch()

  const isAuthenticated = useSelector(authSelectors.getIsAuthenticated)

  useEffect(() => {
    dispatch(generalActions.setIsAuthenticatedRoute.success(isAuthenticatedRoute))
  }, [dispatch, isAuthenticatedRoute])

  const routeRenderFunc = useCallback(
    (props) => {
      if (isAuthenticatedRoute) {
        if (isAuthenticated === null) {
          return null
        }
        if (!isAuthenticated) {
          return <Redirect to={{ pathname: APP_URLS.ROOT, state: { from: props.location } }} />
        }
      }
      return <RouteComponent {...props} />
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [isAuthenticatedRoute, isAuthenticated, RouteComponent],
  )

  return <OriginalRoute {...rest} render={routeRenderFunc} />
}

Route.propTypes = {
  isAuthenticatedRoute: PropTypes.bool,
  ...OriginalRoute.propTypes,
}

export default Route
